export type SpeedingExample = {
    currentValue: string;
    allowedValue: string;
}

export class SpeedingExamplesCalculator {
    static getExamples(speedPercentThreshold: number, speedThresholdAllowance: number, speedUnit: string) : SpeedingExample[] {
        return [
            this.calculate(20, speedPercentThreshold, speedThresholdAllowance, speedUnit),
            this.calculate(40, speedPercentThreshold, speedThresholdAllowance, speedUnit),
            this.calculate(60, speedPercentThreshold, speedThresholdAllowance, speedUnit),
            this.calculate(80, speedPercentThreshold, speedThresholdAllowance, speedUnit),
            this.calculate(100, speedPercentThreshold, speedThresholdAllowance, speedUnit),
        ]
    }

    private static calculate(
        currentValue: number, 
        speedPercentThreshold: number, 
        speedThresholdAllowance: number, 
        speedUnit: string
    ) : SpeedingExample {
        const percentageMultiplier = 1 + (speedPercentThreshold / 100);
        const allowedValue = Math.round(currentValue * percentageMultiplier + speedThresholdAllowance);


        return { 
            currentValue: `${currentValue} ${speedUnit}`,
            allowedValue: `${allowedValue} ${speedUnit}`
        };
    }
}